import { useMemo, useCallback } from "react";

import SwitchButton from "./SwitchButton";

import { ValueConfig } from "@/components/Workflows/types";
import TagInput from "@/components/ui/TagInput";
import { parseTagsFromString } from "@/utils/tagUtils";

interface TagStaticInputProps {
  inputValue: string;
  className?: string;
  placeholder?: string;
  onChange?: (value: ValueConfig) => void;
  onSourceSwitch: (e: React.MouseEvent) => void;
  readonly?: boolean;
}

const TagStaticInput = ({
  inputValue,

  placeholder = "Enter comma-separated values",
  onChange,
  onSourceSwitch,
  readonly,
}: TagStaticInputProps) => {
  const initialTags = useMemo(() => parseTagsFromString(inputValue), [inputValue]);

  const handleTagsChange = useCallback(
    (tags: string[]) => {
      onChange?.({ static_value: tags.join(",") });
    },
    [onChange],
  );

  return (
    <div className="mb-auto flex w-full flex-col gap-2">
      {!readonly && (
        <SwitchButton toSource onSourceSwitch={onSourceSwitch} onStaticSwitch={() => undefined} />
      )}
      <TagInput
        initialTags={initialTags}
        onTagsChange={handleTagsChange}
        disabled={readonly}
        placeholder={!readonly ? placeholder : ""}
      />
    </div>
  );
};

export default TagStaticInput;
